"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ExplicitContentStatementModal = exports.UserSubmissionGuidelinesModal = exports.default = void 0;

var _base = babelHelpers.interopRequireDefault(require("./base"));

var _promisePolyfill = babelHelpers.interopRequireDefault(require("promise-polyfill"));

var TextModal =
/*#__PURE__*/
function (_Modal) {
  babelHelpers.inherits(TextModal, _Modal);

  function TextModal(id, title, contentUrl) {
    var _this;

    babelHelpers.classCallCheck(this, TextModal);
    _this = babelHelpers.possibleConstructorReturn(this, babelHelpers.getPrototypeOf(TextModal).call(this, id));
    _this.classList = _this.classList.concat('text-modal');
    _this._title = title;
    _this._contentUrl = contentUrl;
    return _this;
  }

  babelHelpers.createClass(TextModal, [{
    key: "getModalContent",
    value: function getModalContent() {
      var _this2 = this;

      if (!this.modalContentPromise) {
        this.modalContentPromise = new _promisePolyfill.default(function (resolve) {
          $.get(_this2._contentUrl, function (data) {
            resolve(data);
          });
        });
      }

      return this.modalContentPromise;
    }
  }, {
    key: "icon",
    get: function get() {
      return "";
    }
  }, {
    key: "title",
    get: function get() {
      return this._title;
    }
  }]);
  return TextModal;
}(_base.default);

var _default = TextModal;
exports.default = _default;
var UserSubmissionGuidelinesModal = new TextModal('user-submission-guidelines-modal', 'User Submission Guidelines', 'data/legal?notice=UserSubmissionGuidelines');
exports.UserSubmissionGuidelinesModal = UserSubmissionGuidelinesModal;
var ExplicitContentStatementModal = new TextModal('explicit-content-statement-modal', 'Explicit Content Statement', 'data/legal?notice=ExplicitContentStatement');
exports.ExplicitContentStatementModal = ExplicitContentStatementModal;